import { connect } from 'react-redux';
import get from 'lodash/get';
import RankingCreate from './RankingCreate';
import { actions as PageAction } from '@pages/names';

import {
  createRanking as createRankingService,
  saveRanking
} from '../../service/ranking';

export const createRanking = () => (dispatch, getState) => {
  let { jwToken, createRanking: { name } } = getState();

  dispatch({ type: 'CREATE_RANKING_SAVING' });

  return createRankingService(jwToken, name).then(res => {
    dispatch({ type: 'RANKINGS_ADD', payload: res.data });

    dispatch({
      type: PageAction.RankingDetails,
      payload: { id: get(res, 'data._id') }
    });

    dispatch({ type: 'CREATE_RANKING_CLEAR' });
  });
};

export const updateName = () => (dispatch, getState) => {
  let { jwToken, rankingDetails, createRanking: { name } } = getState();

  dispatch({ type: 'RANKING_PARTICIPANTS_SAVING', payload: true });
  return saveRanking(jwToken, rankingDetails._id, { name }).then(res => {
    dispatch({
      type: 'RANKING_DETAILS_SET',
      payload: res.data
    });

    dispatch({ type: 'RANKING_PARTICIPANTS_CLEAR' });
    dispatch({ type: 'CREATE_RANKING_CLEAR' });
  });
};

export const mapStateToProps = ({ createRanking }) => ({
  ...createRanking,
  canSave: !!(get(createRanking, 'name', '').trim().length >= 6)
});

export const mapDispatchToProps = (dispatch, ownProps) => ({
  onOk: () => {
    get(ownProps, 'editMode', false)
      ? dispatch(updateName())
      : dispatch(createRanking());
  },
  onChangeName: ({ target }) =>
    dispatch({ type: 'CREATE_RANKING_NAME', payload: target.value }),
  onCancel: () => dispatch({ type: 'CREATE_RANKING_VISIBLE', payload: false })
});

export default connect(mapStateToProps, mapDispatchToProps)(RankingCreate);
